import ko from 'knockout';

export default class ViewModel {
  constructor({
    items,
    selectedIndex,
    tabPanelId,
  }) {
    this.items = items;
    this.tabPanelId = tabPanelId;
    this.selectedIndex = ko.observable(selectedIndex);

    this.selected = ko.computed(() => this.items[this.selectedIndex()]);
  }
}
